export default __webpack_public_path__ + "assets/images/11c962df06a03e0eef83a846386e7c05.png";